import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class AmazonImportArgs {
  @Field()
  penName!: string

  @Field({ nullable: true })
  needle?: string
}
